<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    placeholder="请选择结算方式"
    :clearable="clearable"
    idKey="SettleId"
    labelKey="SettleName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/settle").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

